import { render, staticRenderFns } from "./OtherEvents.vue?vue&type=template&id=0895ddb3&scoped=true&"
import script from "./OtherEvents.vue?vue&type=script&lang=js&"
export * from "./OtherEvents.vue?vue&type=script&lang=js&"
import style0 from "./OtherEvents.vue?vue&type=style&index=0&id=0895ddb3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895ddb3",
  null
  
)

export default component.exports